import { useMemo, memo } from "react";
import { useSelector } from "react-redux";
// eslint-disable-next-line you-dont-need-lodash-underscore/values
import { values } from "lodash";
import { selectIsEventManager } from "modules/event/selectors";
import { selectRooms } from "store/rooms";
import { IRoom } from "types";
import { useLockTable } from "modules/lockTables/hooks";
import { selectHoveredTableCode as selectAssignedShuffleHoveredTableCode } from "modules/assignTables/redux";
import RoomComponent from "../RoomComponent";

export const LayoutComponent = memo(
  ({ isLockTablesEnabled }: { isLockTablesEnabled: boolean }) => {
    const rooms = useSelector(selectRooms);
    const { lockedTables } = useLockTable();

    const roomsArray = useMemo(
      () =>
        values(rooms).sort((a, b) => {
          if (a.order && b.order) {
            return a.order - b.order;
          }

          return 0;
        }),
      [rooms],
    );

    const isEventManager = useSelector(selectIsEventManager);
    const hoveredAssignedShuffleTableCode = useSelector(
      selectAssignedShuffleHoveredTableCode,
    );

    if (!roomsArray || !roomsArray.length) {
      return null;
    }

    const renderRooms = (subset: IRoom[]) =>
      subset
        .filter(({ code }) => code !== "left-board" && code !== "right-board")
        .map((room: IRoom) => {
          const { id } = room;

          return (
            <RoomComponent
              lockTableInfo={lockedTables.find(({ table }) => table === id)}
              isLockTablesEnabled={isLockTablesEnabled}
              key={id}
              roomId={id}
              isEventManager={isEventManager}
              autoAssignRoom
              outlined={hoveredAssignedShuffleTableCode === room.code}
            />
          );
        });

    return <>{renderRooms(roomsArray)}</>;
  },
);
